module.exports = __webpack_public_path__ + "static/media/snappy-ai.8c728ce5.svg";